module.exports = __webpack_public_path__ + "static/img/iconfont.66394aeb.svg";